var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFatLeft = function SvgIconArrowFatLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.633 2.076A1 1 0 0 1 12.25 3v3.5h7.25a1.75 1.75 0 0 1 1.75 1.75v7.5a1.75 1.75 0 0 1-1.75 1.75h-7.25V21a1 1 0 0 1-1.707.707l-9-9a1 1 0 0 1 0-1.414l9-9a1 1 0 0 1 1.09-.217M3.664 12l6.586 6.586V16.5a1 1 0 0 1 1-1h8v-7h-8a1 1 0 0 1-1-1V5.414z",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowFatLeft;